<template>
  <!-- HTML 정의하는 부분 -->
  <!-- 1차 퍼블리셔가 작업 영역 -->
  <!-- 2차 개발자가 Template 화 작업 진행-->
  <v-card elevation="0" width="450px">
    <v-card-title class="pl-2">
      <!-- <img :src="chargeImage" style="font-size: 1rem;" alt> -->
      <span :class="freeBtn">{{ freeBtn === 'normalBtn' ? '일 반' : '프리미엄' }}</span>
      <span class="pl-2" style="font-size: 1.3rem!important">{{infoData.DESCRIPTION}}</span>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="pt-0" md="11">
          <v-row>
            <v-col
              class="py-0 text-body-2"
              md="3"
              style=" padding-left: 5px; padding-right: 5px;"
              cols="3"
            >주소</v-col>
            <v-col
              cols="9"
              class="py-0 text-body-2"
              style="padding-left: 2px;"
            >{{infoData.LOCATION}}</v-col>
          </v-row>
          <v-row class="pa-0">
            <v-col
              cols="3"
              class="text-body-2 py-0"
              md="3"
              style=" padding-left: 5px; padding-right: 5px;"
            >설치일자</v-col>
            <v-col
              cols="9"
              class="text-body-2 py-0"
              style="padding-left: 2px;"
            >{{infoData.CRT_DATE | v_date}}</v-col>
          </v-row>
        </v-col>
        <!-- <v-col class="pt-0 pl-1" md="1">
          <v-btn
            small
            id="cctvBtn"
            @click="goCctv"
            v-show="cctvView"
            color="#0784F2"
            class="mb-3"
            width="80"
          >
            <v-icon>mdi-cctv</v-icon>CCTV
          </v-btn>
          <v-btn small id="infoBtn" color="#0784F2" @click="pageRedirect" width="80">상세보기</v-btn>
        </v-col>-->
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex justify-end py-0">
          <v-btn
            class="listBtn px-2"
            id="cctvBtn"
            @click="goCctv"
            v-show="cctvView"
            color="#0784F2"
            style="color: white"
          >
            <v-icon size="1rem" style="color: white">mdi-cctv</v-icon>CCTV
          </v-btn>
          <v-btn
            class="listBtn px-2 ml-2"
            id="infoBtn"
            style="color: var(--v-white-base); background-color: #0784F2;"
            @closeDetailPop="viewPopup=false"
            @click="pageRedirect"
          >상세보기</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog
      transition="dialog-bottom-transition"
      fullscreen
      v-if="viewPopup"
      v-model="viewPopup"
      persistent
      max-width="600px"
    >
      <cctv-popup
        @closeDetailPop="viewPopup=false"
        :cctv-cnt="infoData.CCTV_CNT"
        :site-id="infoData.SITE_ID"
      ></cctv-popup>
    </v-dialog>
  </v-card>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
// [ECMA6] export default 된 부분이 외부에서 import로 사용할 수 있게 된다.
import day from 'dayjs'
import { isTablet, isMobile } from '@/utils/check'
import cctvPopup from '@/views/pc/site/CctvPopup'
export default {
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  name: 'SiteInfoDialog',
  props: {
    infoData: {
      type: Object,
      default: () => {
        return {
          siteId: 'M2189',
          title: '테스트 홍성 지정리 지정3호태양광',
          location: '테스트 충청남도 홍성군 구항면 지정리 129',
          date: day('2020-11-13T15:00:00.000+0000').format('YYYY년 MM월 DD일'),
          charge: '유료',
          cctvView: true
        }
      }
    }
  },
  components: {
    cctvPopup
  },
  filters: {
    v_date: function(d) {
      const _day = new Date(d)
      let mons
      if (_day.getMonth() + 1 < 10) {
        mons = '0' + (_day.getMonth() + 1)
      } else {
        mons = _day.getMonth() + 1
      }
      return _day.getFullYear() + '-' + mons + '-' + _day.getDate()
    }
  },
  data() {
    return {
      charge: require('@/assets/image/monitoring/mark-charge.png'),
      free: require('@/assets/image/monitoring/mark-free.png'),
      r_free: 'normalBtn',
      r_charge: 'premiumBtn',
      viewPopup: false
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
  },
  mounted() {
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
  },
  computed: {
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    installDate() {
      return day(this.infoData.CRT_DATE).format('YYYY년 MM월 DD일')
    },
    chargeImage() {
      if (this.infoData.TYPE === '유료') {
        return this.charge
      } else {
        return this.free
      }
    },
    freeBtn() {
      if (this.infoData.TYPE === '유료') {
        return this.r_charge
      } else {
        return this.r_free
      }
    },
    cctvView() {
      return this.infoData.CCTV_STAT !== null && this.infoData.CCTV_STAT !== 'N'
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    goCctv() {
      // const params =
      //   '?siteId=' +
      //   this.infoData.SITE_ID +
      //   '&cctvCnt=' +
      //   this.infoData.CCTV_CNT
      // this.$router.push('/cctvPopup' + params)
      this.viewPopup = true
    },
    pageRedirect() {
      // console.log('클릭!!!')
      this.$store.dispatch('SetLoadingDialog', true)
      this.$emit('closeDetailPop')
      if (this.infoData.SITE_ID.indexOf('E') > -1) {
        this.$router.push(
          '/mobile/ess/siteWork?site_id=' + this.infoData.SITE_ID
        )
      } else {
        this.$router.push('/mobile/siteWork?site_id=' + this.infoData.SITE_ID)
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
/* 퍼블리셔 작업 영역 */

// lang="less"로 <style> 태그에 속성으로 넣어야 less를 사용할 수 있다.

.test-box {
  border: 1px solid lightgreen;
}
.ft {
  font-family: Noto Sans KR !important;
  font-size: 13px !important;
}
.normalBtn {
  font-size: 12px;
  background-color: var(--v-normalBtnBg-base);
  color: var(--v-normalBtntext-base);
  width: 42px;
  border-radius: 4px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.premiumBtn {
  font-size: 12px;
  background-color: var(--v-premiumBtnBg-base);
  color: var(--v-premiumBtntext-base);
  width: 56px;
  border-radius: 4px;
  height: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-body-2 {
  font-size: 1rem !important;
}
.listBtn {
  font-size: 0.8rem !important;
  height: 30px !important;
}
</style>
